import { CustomOffsetRecord } from '../core/custom-offsets';
import { MessageType } from '../core/reminders';
import type { HttpClient } from './http';

export interface CustomOffsetsService {
  getCustomOffsets: (
    messageType?: MessageType,
  ) => Promise<CustomOffsetRecord[]>;
  addCustomOffset: (
    offset: number,
    messageType: MessageType,
  ) => Promise<CustomOffsetRecord>;
  canRemoveCustomOffset: (
    id: string,
    ignoreMessageTemplateId?: string,
  ) => Promise<boolean>;
  removeCustomOffset: (id: string) => Promise<void>;
}

export function createCustomOffsetsService(
  httpClient: HttpClient,
  baseUrl: string,
): CustomOffsetsService {
  return {
    getCustomOffsets: (messageType?: MessageType) => {
      return httpClient<CustomOffsetRecord[]>(
        `${baseUrl}/custom-offsets`,
        'get',
        { query: { messageType } },
      );
    },

    addCustomOffset: (offset: number, messageType: MessageType) => {
      return httpClient<CustomOffsetRecord>(
        `${baseUrl}/custom-offsets`,
        'post',
        { body: { offset, message_type: messageType } },
      );
    },

    canRemoveCustomOffset: (id: string, ignoreMessageTemplateId?: string) => {
      return httpClient<boolean>(
        `${baseUrl}/custom-offsets/${id}/can-remove`,
        'get',
        { query: { ignoreMessageTemplateId } },
      );
    },

    removeCustomOffset: (id: string) => {
      return httpClient<void>(`${baseUrl}/custom-offsets/${id}`, 'delete');
    },
  };
}
